<span
  class="hover-text"
  triggers="mouseenter:mouseleave"
  placement="auto"
  container="body"
  [ngbPopover]="powerLimitation">
  {{ value }}
</span>

<ng-template #powerLimitation>
  @if (customMessage) {
    <mat-list>
      <mat-list-item>
        <h3 matListItemTitle>{{ title }}</h3>
        <p matListItemLine>{{ customMessage }}</p>
      </mat-list-item>
    </mat-list>
  } @else {
    <div class="m-4">
      <h3>{{ title }}</h3>

      @if (selectedChargingProfile.limitation_reason) {
        <p class="max-w-80">
          {{ cleanStringLimitation(selectedChargingProfile.limitation_reason) | translate }}
        </p>
      }
    </div>

    <mat-list class="max-w-80">
      @if (isNum(selectedChargingProfile.amps_limit)) {
        <mat-list-item>
          <h4 matListItemTitle>{{ 'CURRENT' | translate }}</h4>
          <p matListItemLine
            >{{ selectedChargingProfile.amps_limit
            }}{{ ChargingRateUnitEnum[selectedChargingProfile.chargingRateUnit] }}</p
          >
        </mat-list-item>
      }

      <mat-list-item>
        <h4 matListItemTitle>{{ 'QUEUE_ORDER' | translate }}</h4>
        <p matListItemLine>{{ selectedChargingProfile.QueueOrder + 1 }}</p>
      </mat-list-item>

      <mat-list-item>
        <h4 matListItemTitle>{{ 'QUEUE_REASON' | translate }}</h4>
        <p matListItemLine>{{ selectedChargingProfile.QueueReason }}</p>
      </mat-list-item>

      @if (selectedChargingProfile.NumberRetries) {
        <mat-list-item>
          <h4 matListItemTitle>{{ 'RETRIES' | translate }}</h4>
          <p matListItemLine>{{ selectedChargingProfile.NumberRetries }}</p>
        </mat-list-item>
      }
    </mat-list>
  }
</ng-template>
